import styled from 'styled-components'
import ShareIcon from 'components/Common/Icons/Share'
import { SecondaryIconButtonFlexable32 } from 'components/Common/MasterComponents'

const Button = styled(SecondaryIconButtonFlexable32)`
  width: 32px;
  height: 32px;
`

const ShareButton = props => {
  return <Button {...props} icon={<ShareIcon size={16} />} />
}

export default ShareButton
